import EntityService from '@/services/EntityService'
import { User, UserClass } from '@/models/user'
import { collection, query, where, getDocs, doc, setDoc } from 'firebase/firestore'
import { httpsCallable } from 'firebase/functions'
import FirebaseService from './FirebaseService'

export default class UserService extends EntityService<User> {
  constructor() {
    super({ collectionName: 'users' })
  }
  async fetchUsers( userType: string | undefined = undefined) {
    const db = await FirebaseService.firestore()
    const usersRef = collection(db, 'users')
    let queryRef = query(usersRef)
    if (userType) queryRef = query(usersRef, where('type', '==', userType))

    const querySnapshot = await getDocs(queryRef)

    if (querySnapshot) {
      const users = querySnapshot.docs.map((doc) => {
        const user = doc.data() as User
        return new UserClass(user)
      })

      return users
    }
  }

  async createUser(user: User) {
    const functions = await FirebaseService.functions()
    const createUser = httpsCallable(functions, 'user-createV2')
    const response = await createUser(user)

    const userData = response.data as User
    return new UserClass(userData)
  }

  async createNoAuthUser(user: User) {
    const functions = await FirebaseService.functions()
    const createUser = httpsCallable(functions, 'user-createNoAuthV2')
    const response = await createUser(user)

    const userData = response.data as User
    return new UserClass(userData)
  }

  async updateUser(user: User) {
    const db = await FirebaseService.firestore()
    const userRef = doc(db, 'users', user.id)
    await setDoc(userRef, {
      name: user.name,
      email: user.email,
      phone: user.phone,
      avatar: user.avatar,
      type: user.type,
      updatedAt: new Date()
    })
    return user
  }
}
